// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import TwoButtonModal, { TwoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { xCommonUpdate } from "@vanmeter/App/Handlers/XNG/Common";
import { CustomAppState } from "@vanmeter/App/Store/Reducers";
import { fontConfig } from "@vanmeter/XDL/constants";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: SignInModalStyles;
}

const mapStateToProps = (state: CustomAppState) => {
    const currentLocation = getLocation(state);
    const returnUrl = encodeURIComponent(`${currentLocation.pathname}${currentLocation.search}`);
    const signInPageUrl = (getPageLinkByPageType(state, "SignInPage")?.url || "") + `?returnUrl=${returnUrl}`;

    return {
        isOpen: state.xCommon?.isSignInModalOpen,
        signInPageUrl,
    };
};

const mapDispatchToProps = {
    closeModal: () => xCommonUpdate({ key: "isSignInModalOpen", value: false }),
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface SignInModalStyles {
    modal?: TwoButtonModalStyles;
    messageTextWrapper?: InjectableCss;
}
export const signInModalStyles: SignInModalStyles = {
    messageTextWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 16px;
            div,
            ${TypographyStyle}, a {
                font-size: ${fontConfig.regular.size}px;
                line-height: ${fontConfig.regular.lineHeight};
                margin-bottom: 0;
            }
        `,
    },
};

const styles = signInModalStyles;

const SignInModal = ({ isOpen, signInPageUrl, history, closeModal }: Props) => {
    const RedirectToSignIn = () => {
        history.push(signInPageUrl);
        closeModal();
    };

    useEffect(() => {
        return () => {
            closeModal();
        };
    }, []);

    return (
        <TwoButtonModal
            {...styles.modal}
            modalIsOpen={isOpen}
            headlineText={translate("Please Log In to Continue")}
            messageText={
                <StyledWrapper {...styles.messageTextWrapper}>
                    {/* {parse(siteMessage("Custom_Continue_SignIn_Message", signInPageUrl) as string, parserOptions)} */}
                    {siteMessage("Custom_Continue_SignIn_Message", signInPageUrl)}
                </StyledWrapper>
            }
            cancelButtonText={translate("Cancel")}
            submitButtonText={translate("Log In")}
            onCancel={() => closeModal()}
            onSubmit={RedirectToSignIn}
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(SignInModal));
